﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKFilterSearch extends TKCustomElementFactory {
    wrapper?: HTMLElement;
    fieldElement?: HTMLInputElement;
    lastChildClassName: string;
    existsMessage: boolean = false;

    constructor() {
        super();

        this.wrapper = this.closest('tk-filter-dropdown') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.lastChildClassName = this.getAttribute('data-tk-last-child-class-name') || 'tk-filter-select--last-child';
    }

    connectedCallback(): void {
        if (!this.wrapper || !this.fieldElement) throw new Error('Filter-Search: Element is missing!');

        this.registerInputListener();
    }

    registerInputListener() {
        const onInput = this.filter.bind(this);
        this.pushListener({ event: 'input', element: this.fieldElement!, action: onInput });
    }

    filter(event: InputEvent) {
        const filterTypes = this.wrapper!.querySelector<HTMLElement>('[data-tk-filter-types]');
        const search = event.target as HTMLInputElement;
        this.resetAll();
        if (!filterTypes || !search) return;
        const value = search.value.toLowerCase();
        const { children } = filterTypes;
        const childList = Array.from(children);
        childList.forEach((child) => {
            const element = child as HTMLElement;
            const input = element.querySelector('input');
            const label = element.querySelector('label');
            element.hidden = (
                !input?.value.toLowerCase().includes(value)
                && !label?.textContent?.toLowerCase().includes(value)
            ) || false;
        });
        const visibleChilds = childList.filter((item) => {
            const element = item as HTMLElement;
            return !element.hidden;
        });
        filterTypes.classList.toggle(this.lastChildClassName, visibleChilds.length === 1);
        if (visibleChilds.length === 0) {
            if (this.existsMessage) return;
            const messageElement = TKFilterSearch.createMessage();
            filterTypes.insertAdjacentElement('beforebegin', messageElement);
            this.existsMessage = true;
        } else if (this.existsMessage) {
            const messageElement = this.wrapper?.querySelector('.tk-message');
            if (!messageElement) return;
            messageElement.remove();
            this.existsMessage = false;
        }
    }

    resetAll() {
        const fiterTypes = this.wrapper!.querySelector<HTMLElement>('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child) => {
            const element = child as HTMLElement;
            element.hidden = false;
        });
    }

    static createMessage() {
        const emptyInfo = document.createElement('div');
        emptyInfo.classList.add(
            'tk-message',
            'tk-message--info',
            'tk-message--fullwidth',
        );
        emptyInfo.textContent = window.opacc.tkFilterMessages?.emptyResult.text || '';
        return emptyInfo;
    }
}